import { ArrowRight } from 'lucide-react';
import { ADVERTISER_REGISTER_URL } from '../lib/links';
import { ctaClass } from '../lib/cta';

interface Step {
  num: string;
  title: string;
  body: string;
}

const STEPS: Step[] = [
  {
    num: '01',
    title: 'Tell us about your brand',
    body: 'Share what you want to say and who you want to reach. A short brief is enough to get started.',
  },
  {
    num: '02',
    title: 'We shape the campaign',
    body: 'We match your message to the right moments and audiences — and confirm everything before anything goes live.',
  },
  {
    num: '03',
    title: 'Watch it land',
    body: 'Reach, engagement, and outcomes show up in your dashboard in real time. Adjust direction whenever you like.',
  },
];

export function HowItWorks() {
  return (
    <section id="how" className="relative">
      <div className="mx-auto max-w-container-lg px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-caps text-primary">
            How it works
          </span>
          <h2 className="mt-3 font-display text-4xl leading-display tracking-display text-ink sm:text-5xl">
            From a first conversation to a campaign{' '}
            <span className="italic text-primary">in days, not weeks.</span>
          </h2>
        </div>

        <ol className="mt-16 grid grid-cols-1 gap-7 md:grid-cols-3">
          {STEPS.map((step, idx) => (
            <li
              key={step.num}
              className="relative rounded-lg border border-border-soft bg-surface p-7 shadow-xs sm:p-8"
            >
              <div className="flex items-center gap-3">
                <span className="font-display text-4xl leading-display text-primary">
                  {step.num}
                </span>
                {idx < STEPS.length - 1 ? (
                  <span aria-hidden className="hidden flex-1 border-t border-dashed border-border-soft md:block" />
                ) : null}
              </div>
              <h3 className="mt-4 font-display text-2xl leading-display text-ink">
                {step.title}
              </h3>
              <p className="mt-2.5 text-base leading-body text-ink-secondary">{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="mt-14 flex justify-center">
          <a href={ADVERTISER_REGISTER_URL} className={ctaClass('primary', 'lg')}>
            Start a campaign
            <ArrowRight className="h-5 w-5" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
}
